import { ForegroundActivity } from './hooks/useForegroundActivity';
import { BrowserRouter } from 'react-router-dom';
import Colors from 'src/assets/Colors';
import Fonts from 'src/assets/Fonts';
import { ReduxProvider } from 'src/state';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import Routes from './routes/Routes';
import 'rc-collapse/assets/index.css';
import { I18nextProvider } from 'react-i18next';
import i18n from 'src/i18n';
import { CreatorRoleProvider } from './hooks/useCreatorRoleContext';

const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: 'readableFont';
    font-style: normal;
    src: url(${Fonts.readableFont});
  }
  html {
    height: 100%;
  }
  body {
    height: 100%;
    background: ${Colors.lightPeach};
    background-attachment:fixed;
    font-family: 'readableFont';
    color: ${Colors.woodyBrown};
    #root {
      height: 100%;
    }
  }

`;

const Application = () => {
    return (
        <I18nextProvider i18n={i18n}>
            <ThemeProvider theme={{}}>
                <GlobalStyle />
                <ReduxProvider>
                    <CreatorRoleProvider>
                        <BrowserRouter>
                            <div id="modal-root" />
                            <ForegroundActivity />
                            <Routes />
                        </BrowserRouter>
                    </CreatorRoleProvider>
                </ReduxProvider>
            </ThemeProvider>
        </I18nextProvider>
    );
};

export default Application;
